import Button, { ButtonModeE } from "../../components/Button/Button";
import { H1 } from "../../components/Text/Text";
import ChangeInternalProjectNumberBody from "./ChangeInternalProjectNumberBody";

import styles from './changeInternalProjectNumber.module.scss';

export default (campaignId: number, removePopup: () => void, internalNumber: string) => ({
    header: <H1>Set internal project number</H1>,
    body: <ChangeInternalProjectNumberBody campaignId={campaignId} internalNumber={internalNumber} />,
    footer: (
        <div className={styles.footerButtonsWrapper}>
            <Button
                mode={ButtonModeE.OUTLINED}
                onClick={removePopup}
            >
                Cancel
            </Button>
            <Button
                form="change-internal-project-number"
                useGlobalLoading
            >
                Save
            </Button>
        </div>
    ),
    className: styles.popupWrapper,
});